export const CHANGE_PRESS = "CHANGE_PRESS";



export const changeSubmitAction = () => ({
  type: CHANGE_PRESS,

});